export var defaultSubjectColors = ['#5F95FF', '#61DDAA', '#65789B', '#F6BD16', '#7262FD', '#78D3F8', '#9661BC', '#F6903D', '#008685', '#F08BB4'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6-core/es/util/color.js
// module id = null
// module chunks = 